<template>
  <v-app id="app_live_tracking">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">NOT AVAILABLE OFFICER LIST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Analyse not available officer data.
          </p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="back()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <template v-slot:append>
          <v-divider vertical thickness="2"></v-divider>
          <v-card-text class="custom_tool_bar_style">
            <v-btn class="custom_pdf_btn" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
            <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-card-text>
        </template>

        <v-divider thickness="2"></v-divider>

        <v-row class="pl-2 pr-6 pa-6">
          <v-col cols="12" md="3">
            <v-card class="mx-auto pa-2 d-flex flex-column justify-center" elevation="0" border="sm opacity-1"
              rounded="md" style="max-width: 100%; height: auto;">
              <div class="d-flex justify-space-between align-center flex-wrap">
                <!-- Text Section -->
                <div style="max-width: 65%;">
                  <p class="custom_page_component_main_title text-body-2 font-weight-bold" style="margin-bottom: 4px;">
                    NOT AVAILABLE OFFICERS
                  </p>
                  <p class="font-weight-bold custom_page_main_sub_title_very_small_red text-h6"
                    style="font-size: 1.25rem;">
                    {{ filteredOfficers.length }}
                  </p>
                </div>

                <!-- Avatar Image Section -->
                <v-avatar tile size="48" class="pa-1 mt-2 mt-sm-0" rounded color="#F5F5F5">
                  <v-img class="ml-0" style="object-fit: contain;"
                    :src="require('@/img/icons/not_availbale_vechile.png')"></v-img>
                </v-avatar>
              </div>
            </v-card>
          </v-col>

          <!-- Search and Autocomplete Section -->
          <v-col cols="12" md="6" offset="3">
            <v-row>
              <v-col cols="12" md="6" class="d-flex">
                <v-autocomplete v-model="selectedOfficerTypes" :items="uniqueOfficerTypes" clearable item-title="title"
                  item-value="value" label="Officer Category" multiple placeholder="All" variant="outlined"
                  density="comfortable" class="custom_input_field_color w-100 mt-5 ml-2"
                  @update:modelValue="filterOfficers" />
              </v-col>

              <v-col cols="12" md="6" class="d-flex">
                <v-text-field v-model="search" density="comfortable" class="custom_input_field_color w-100 mt-5 ml-2"
                  label="Search" persistent-placeholder placeholder="Search" variant="outlined" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>


        <v-card-text>
          <v-data-table :headers="headers" :items="filteredOfficers" :search="search" class="custom_table_normal">
            <template v-slot:[`item.action`]="{ item }" v-if="permissions.write">
              <v-switch v-model="item.active_status" :false-value="0" :true-value="1" hide-details color="#0e41ed"
                label="Disable" @change="toggleEnable(item)"></v-switch>
              <p class="text-caption font-weight-medium mb-3">
                Tracking Avaliability
              </p>
            </template>

            <template v-slot:[`item.name`]="{ item }">
              <p class="text-caption custom_page_main_sub_title font-weight-bold">
                {{ item.name }}
              </p>
              <p class="custom_page_main_sub_title_very_small_red text-caption font-weight-medium mb-3">
                Employee ID : {{ item.registration_num }}
              </p>
            </template>

            <template v-slot:[`item.officer_type`]="{ item }">
              <v-row>
                <v-col cols="12" md="12" lg="12">
                  <v-chip class="custom_green_chip" size="small" variant="outlined">
                    {{ item.user_catagory.role_type }}
                  </v-chip>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import axios from "axios";
import { getPermissions } from "@/plugins/permissions";
// eslint-disable-next-line
import _ from "lodash";

export default {
  data() {
    return {
      search: "",
      permissions: {},
      headers: [
        {
          text: "OFFICER NAME",
          value: "name",
          title: "OFFICER NAME",
          sortable: true,
        },
        {
          text: "PREMISE CODE",
          value: "prem_code",
          title: "PREMISE CODE",
          sortable: true,
        },
        {
          text: "DIVISION CODE",
          value: "division_code",
          title: "DIVISION CODE",
          sortable: true,
        },
        
        {
          text: "OFFICER CATEGORY",
          value: "officer_type",
          title: "OFFICER CATEGORY",
          sortable: true,
        },
        { text: "Actions", value: "action", sortable: false, title: "ACTION" },
      ],
      selectedOfficerTypes: [],
      officerTypeOptions: [],
      allOfficers: [],
      filteredOfficers: [],
    };
  },

  computed: {
    ...mapGetters({
      agentListDetails: "getagentListDetails",
    }),

    uniqueOfficerTypes() {
      const types = new Set();
      this.allOfficers.forEach(officer => {
        // console.log(officer.user_catagory.role_type);
        types.add(officer.user_catagory.role_type);
      });
      return Array.from(types).map(type => ({
        title: type,
        value: type
      }));
    }
  },

  mounted() {
    this.getAllAgents();
    const dashboardId = 7;
    this.permissions = getPermissions(dashboardId);
    this.getDashboardPermissions();
  },

  methods: {
    back() {
      this.$router.push("/live-tracking");
    },

    toggleEnable(item) {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("agentId", item.id);
      formData.append("activeStatus", item.active_status);

      axios
        .post("/api/updateTracking/activeStatus", formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.getAllAgents();
          } else {
            console.error("Error:");
          }
        })
        .catch((error) => {
          console.error("Error fetching chart details:", error);
        });
    },

    getDashboardPermissions() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post(
          `/api/getDashboard?userId=${userId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          const dashboards = response.data.data;
          this.permissionsItems = dashboards.map((dashboard) => ({
            id: dashboard.id,
            premission_dashboard: dashboard.premission_dashboard,
            isOn: false,
            permissions: { read: false, write: false, delete: false },
          }));
        })
        .catch((error) => {
          console.error("Error fetching dashboard permissions:", error);
        });
    },

    getAllAgents() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("userId", userId);

      axios
        .post("/api/getAgentList", formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const agentList = response.data.data;
            // this.allOfficers = _.filter(
            //   agentList,
            //   (agent) => agent.active_status === 1
            // );
            this.allOfficers = _.filter(agentList, (agent) => agent.active_status === 0 || agent.active_status === null);

            // Extract unique officer types for filter options
            // const uniqueTypes = _.uniqBy(this.allOfficers, "user_type").map(
            //   (officer) => ({
            //     text: officer.user_type,
            //     value: officer.user_type,
            //   })
            // );

            // this.officerTypeOptions = uniqueTypes;
            this.filteredOfficers = [...this.allOfficers]; // Initialize filtered list with all officers
          } else {
            console.error("Error:");
          }
        })
        .catch((error) => {
          console.error("Error fetching chart details:", error);
        });
    },

    filterOfficers() {
      if (this.selectedOfficerTypes.length === 0) {
        // If no types selected, show all not available officers
        this.filteredOfficers = [...this.allOfficers];
      } else {
        // Filter officers based on selected types
        this.filteredOfficers = this.allOfficers.filter((officer) =>
          this.selectedOfficerTypes.includes(officer.user_catagory.role_type)
        );
      }
    },

    exportPDF() {
      const doc = new jsPDF();
      doc.setFontSize(16);
      doc.text("Not Available Officer Report", 14, 7);
      doc.setFontSize(10);
      // doc.text("Officer report with details", 14, 28);

      const tableColumns = [
        "Officer Name",
        "Employee ID",
        "Officer Category",
        "Email",
        "Premise Code",
        "Division Code",
      ];

      const tableData = this.filteredOfficers.map((item) => [
        item.name,
        item.registration_num,
        item.user_catagory.role_type,
        item.email,
        item.prem_code,
        item.division_code,
      ]);

      doc.autoTable({
        head: [tableColumns],
        body: tableData,
        startX: 35,
        theme: "grid",
        headStyles: {
          fillColor: [40, 40, 200],
          textColor: [255, 255, 255],
          fontSize: 5,
          halign: "center",
          valign: "middle",
          cellPadding: 0.5,
        },
        bodyStyles: {
          fontSize: 5,
          textColor: [50, 50, 50],
          halign: "center",
          valign: "middle",
          cellPadding: 0.5,
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240],
        },
        columnStyles: {
          0: { cellWidth: 12 },
          1: { cellWidth: 12 },
          2: { cellWidth: 12 },
          3: { cellWidth: 20 },
          4: { cellWidth: 12 },
          5: { cellWidth: 12 },
          6: { cellWidth: 12 },
          7: { cellWidth: 12 },
        },
        margin: { top: 10 },
      });

      doc.setFontSize(10);
      doc.text(
        `Generated on: ${new Date().toLocaleDateString()}`,
        14,
        doc.internal.pageSize.height - 10
      );
      doc.save("Not Available Officers.pdf");
    },

    exportExcel() {
      const tableData = this.filteredOfficers.map((item) => ({
        "OFFICER NAME": item.name,
        "EMPLOYEE ID": item.registration_num,
        "OFFICER CATEGORY": item.user_catagory.role_type,
        "EMAIL": item.email,
        "PREMISE CODE": item.prem_code,
        "DIVISION CODE": item.division_code,
      }));

      const headers = [
        "OFFICER NAME",
        "EMPLOYEE ID",
        "OFFICER CATEGORY",
        "EMAIL",
        "PREMISE CODE",
        "DIVISION CODE",
      ];

      if (tableData.length === 0) {
        tableData.push(
          headers.reduce((obj, header) => {
            obj[header] = "";
            return obj;
          }, {})
        );
      }

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      worksheet["!cols"] = [
        { wch: 20 },
        { wch: 15 },
        { wch: 10 },
        { wch: 25 },
        { wch: 15 },
        { wch: 10 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
      ];

      worksheet["!freeze"] = { ySplit: 1 };
      const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
          font: { bold: true },
          alignment: { horizontal: "center" },
        };
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Not Available Officer Reports"
      );
      XLSX.writeFile(workbook, "Not Available Officers.xlsx");
    },
  },
};
</script>

<style>
@import "../../styles/tracking_management/live_tracking.scss";
</style>